import { X } from "lucide-react";
import { Button } from "@/v2/components/ui/button";
import { Checkbox } from "@/v2/components/ui/checkbox";

interface SelectionBarProps {
	selectedCount: number;
	allCurrentPageSelected: boolean;
	someCurrentPageSelected: boolean;
	onSelectAll: () => void;
	onClose: () => void;
}

export function SelectionBar({ selectedCount, allCurrentPageSelected, someCurrentPageSelected, onSelectAll, onClose }: SelectionBarProps) {
	return (
		<div className="relative flex h-full w-full items-center justify-between px-3">
			<div className="flex items-center gap-2 text-sm text-muted-foreground z-10">
				<Checkbox
					checked={allCurrentPageSelected ? true : someCurrentPageSelected ? "indeterminate" : false}
					onCheckedChange={onSelectAll}
				/>
				<span onClick={onSelectAll} className="cursor-pointer hover:text-foreground transition-colors">
					{allCurrentPageSelected ? "Deselect All" : "Select All"}
				</span>
			</div>

			<span className="absolute inset-0 flex items-center justify-center text-sm font-medium pointer-events-none">
				{selectedCount} selected
			</span>

			<Button variant="ghost" size="icon" className="h-8 w-8 text-muted-foreground z-10" onClick={onClose}>
				<X className="size-4" />
			</Button>
		</div>
	);
}
